<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">Type of terrain (check all that apply)</div>
		<case-form :schema="schemaTerrain" />

		<div
			class="fs4 fw7 lh125 mt6 mb2"
		>Provide details of your climbs for the past 3 years.</div>

		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Climb Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaClimbs(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: "How long have you been climbing?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingForHowLong`,
					props: {
						suggest: {
							typeIncludes: `climbingForHowLong`
						},
						createOptions: {
							type: `climbingForHowLong`,
							dataType: "string"
						}
					}
				},
				{
					label: "How often do you climb?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingHowOften`,
					props: {
						suggest: {
							typeIncludes: `climbingHowOften`
						},
						createOptions: {
							type: `climbingHowOften`,
							dataType: "string"
						}
					}
				},
				{
					label: "At what level do you climb?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingLevel`,
					props: {
						suggest: {
							typeIncludes: `climbingLevel`
						},
						createOptions: {
							type: `climbingLevel`,
							dataType: "string"
						}
					}
				},
				{
					label: "In which seasons do you climb?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingSeason`,
					props: {
						suggest: {
							typeIncludes: `climbingSeason`
						},
						createOptions: {
							type: `climbingSeason`,
							dataType: "string"
						}
					}
				},
				{
					label: "Do you climb alone?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isClimbAlone`,
					props: {
						suggest: {
							typeIncludes: `isClimbAlone`
						},
						createOptions: {
							type: `isClimbAlone`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbAloneDetails`,
					props: {
						suggest: {
							typeIncludes: `climbAloneDetails`
						},
						createOptions: {
							type: `climbAloneDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Do you climb without ropes?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isClimbWithoutRopes`,
					props: {
						suggest: {
							typeIncludes: `isClimbWithoutRopes`
						},
						createOptions: {
							type: `isClimbWithoutRopes`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbWithoutRopesDetails`,
					props: {
						suggest: {
							typeIncludes: `climbWithoutRopesDetails`
						},
						createOptions: {
							type: `climbWithoutRopesDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Climbing equipment typically used",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingEquipmentUsed`,
					props: {
						suggest: {
							typeIncludes: `climbingEquipmentUsed`
						},
						createOptions: {
							type: `climbingEquipmentUsed`,
							dataType: "string"
						}
					}
				},
				{
					label: "What climbs have you planned for the future",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0plannedClimbs`,
					props: {
						suggest: {
							typeIncludes: `plannedClimbs`
						},
						createOptions: {
							type: `plannedClimbs`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTerrain() {
			return [
				{
					label: "Trail",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainTrail`,
					props: {
						suggest: {
							typeIncludes: `isTerrainTrail`
						},
						createOptions: {
							type: `isTerrainTrail`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Rock",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainRock`,
					props: {
						suggest: {
							typeIncludes: `isTerrainRock`
						},
						createOptions: {
							type: `isTerrainRock`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Ice",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainIce`,
					props: {
						suggest: {
							typeIncludes: `isTerrainIce`
						},
						createOptions: {
							type: `isTerrainIce`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Snow",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainSnow`,
					props: {
						suggest: {
							typeIncludes: `isTerrainSnow`
						},
						createOptions: {
							type: `isTerrainSnow`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Glacier",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainGlacier`,
					props: {
						suggest: {
							typeIncludes: `isTerrainGlacier`
						},
						createOptions: {
							type: `isTerrainGlacier`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Other",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainOther`,
					props: {
						suggest: {
							typeIncludes: `isTerrainOther`
						},
						createOptions: {
							type: `isTerrainOther`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "(Details)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0terrainOtherDetails`,
					props: {
						suggest: {
							typeIncludes: `terrainOtherDetails`
						},
						createOptions: {
							type: `terrainOtherDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaClimbs(i) {
			return [
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryDate${i}`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryDate${i}`
						},
						createOptions: {
							type: `climbHistoryDate${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: "Name of Mountain(s)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryMountain${i}`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryMountain${i}`
						},
						createOptions: {
							type: `climbHistoryMountain${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: "Location",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryLocation${i}`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryLocation${i}`
						},
						createOptions: {
							type: `climbHistoryLocation${i}`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Degree of difficulty (if severe indicate maximum technical grade)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryDifficulty${i}`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryDifficulty${i}`
						},
						createOptions: {
							type: `climbHistoryDifficulty${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
